import { lazy } from "react";

export const AdminReviewsAsync = lazy(() => import("./Reviews"));
